import * as angular from 'angular';
import * as _ from 'lodash';

import { IUserService } from '../../services';
import { ComponentDefinition } from '../../models';

class RecipientListController implements angular.IComponentController {
    displayProperty: string = 'userName';
    formController: angular.IFormController;
    isLoading: boolean;
    loadingMessage: string;
    property: string = 'id';
    recipients: string[];
    unusedUsers: any[];
    users: any[];

    static $inject = ['userService'];

    constructor(private _userService: IUserService) {
    }

    $onInit() {
        this.isLoading = true;
        this._userService.getUsersWithEMailAddress()
            .then(data => {
                this.users = data;
                if (this.recipients) {
                    this.unusedUsers = this.users;
                }
            })
            .finally(() => {
                this.isLoading = false;
            });
    }

    addRecipient(data) {
        const userId = data.itemId.replace('user', '');
        const user = _.find(this.users, u => u.id === userId);
        if (user) {
            const propty = user[this.property];
            if (!this.recipients) {
                this.recipients = [];
            }
            if (this.recipients.indexOf(propty) < 0) {
                this.recipients.push(propty);
                if (this.formController) {
                    this.formController.$setDirty();
                }
            }
        }
    }

}

export const wtRecipientList: ComponentDefinition = {
    componentId: 'wtRecipientList',
    controller: RecipientListController,
    template: require('./recipientList.component.html'),
    controllerAs: 'vm',
    bindings: {
        recipients: '=',
        property: '@?',
        displayProperty: '@?',
        formController: '='
    }
};
